// extracted by mini-css-extract-plugin
module.exports = {"container":"_1TpTn","post":"_1Ojis","hashtags":"_1UofM","separator":"_1mIOa","content":"_1gXp4","commentExcerpt":"_1rw-4"};